import { AiVariant } from 'modules/mel-ai';

import { VariantItemWrapper } from './variant-item-wrapper';

interface ProsVariantMapProps {
  selectedVariantState: [AiVariant | null, React.Dispatch<React.SetStateAction<AiVariant | null>>];
  variants: AiVariant[];
}

const ProsVariantMap = ({ selectedVariantState, variants }: ProsVariantMapProps) => {
  return (
    <>
      {variants.map((item) => {
        const pro = item.value;

        return (
          <VariantItemWrapper
            key={item.id}
            selectedVariantState={selectedVariantState}
            variant={item}
          >
            {pro.split('- ').map((item) => (
              <div key={item}>{item}</div>
            ))}
          </VariantItemWrapper>
        );
      })}
    </>
  );
};

export { ProsVariantMap };
